<template>
  <b-tabs>
    <b-tab title="Discounts"><Offers/></b-tab>
    <b-tab title="Materials"><Materials/></b-tab>
  </b-tabs>
</template>

<script>
import Offers from './Offers'
import Materials from './Materials'
import { mapMutations } from 'vuex'

export default {
  name: 'TheToolbox',
  components: {
    Offers,
    Materials
  },
  methods: {
    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ])
  },
  created () {
    this.setViewname(this.$t('toolbox.viewtitle'))
    this.endLoading()
  }
}
</script>
